import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCRUD, CRUDService, ExceptionService, PaginatedList, UtilsService } from './../../xform-compat';
import { Observable } from 'rxjs';
import { RmsUser, Draft } from '../../shared/models';
import { catchError } from 'rxjs/operators';


/**
 * Data service for the CRUD of My Companies
 */
@Injectable()
export class MyDraftsService extends AbstractCRUD<Draft> implements CRUDService<Draft> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService
  ) {
    super(exceptionService, http, utilsService);
  }

  getResourcePath(): string {
    return '/rms/drafts';
  }

  /**
   * Deletes a draft from the provided space id
   * @param spaceId
   * @param draftId
   */
  public deleteDraft (spaceId: number, draftId: number): Observable<void> {
    return super.getHTTP()
      .delete(`/api/rms/spaces/${spaceId}/notes/${draftId}/draft/me`)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  /**
   * Autocompletes authors to filter drafts
   * * @param term
   */
  public autocompleteAuthors (term: string): Observable<PaginatedList<RmsUser>> {
    return super.getHTTP().get(`/api/rms/drafts/authors?q=${term}`).pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }
}
